import { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { LocalFireDepartment as FireIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { computeStreak } from '@/utils/activityStreak'
import type { HeatmapPoint } from '@/types/dashboard'

interface ActivityStreakCardProps {
  days: HeatmapPoint[]
}

/**
 * Серия дней — как в виджете дашборда, но считается из уже загруженных точек
 * heatmap, без отдельного запроса.
 */
export function ActivityStreakCard({ days }: ActivityStreakCardProps) {
  const { t } = useTranslation()
  const { current, longest } = useMemo(() => computeStreak(days), [days])

  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
        {t('dashboard.widgets.streak.title')}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <FireIcon color={current > 0 ? 'warning' : 'disabled'} />
          <Typography variant="h5" fontWeight={700}>
            {current}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t('dashboard.widgets.streak.days')}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary" display="block">
            {t('dashboard.widgets.streak.current')}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t('dashboard.widgets.streak.longest')}: <b>{longest}</b>
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
